import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import { useEntities } from "@hooks/useEntities";
import { Entity } from "@common/types/entity";
import { ChartOfAccountsRow } from "../utils";

export const EntitiesCell = memo(
    ({ row }: CellContext<ViewTableFeatures, ChartOfAccountsRow, number[]>) => {
        const rowData = row.original;
        const entities = useEntities({ onlyBusiness: true });

        // Classification row - no entities
        if (rowData.classification) {
            return <ViewTableCell />;
        }

        // Account row
        if (rowData.entityIds) {
            return (
                <ViewTableCell>
                    <EntityAvatarGroup
                        entities={entities.filter((entity: Entity) =>
                            rowData.entityIds?.includes(entity.id),
                        )}
                        max={3}
                        size="xs"
                    />
                </ViewTableCell>
            );
        }

        return <ViewTableCell />;
    },
);
